import { useRouter } from 'next/router';

import useHashLocation from 'lib/hooks/useHashLocation';

export function useSimilarListingPath(vin: string): string {
  const { cleanKeys, values } = useHashLocation();
  const { asPath: url } = useRouter();
  const newHashLocationString = cleanKeys({ ...values, vin });
  const urlBase = url.split('#')[0];
  return `${urlBase}#${newHashLocationString}`;
}
